export default class AdCarousel {
    constructor(context) {
        this.context = context;

        if (typeof Swiper === 'function') {
            this.storeElements();
            this.initSwiper();
        }
    }

    storeElements() {
        const carouselContainer = this.context.parentNode;

        this.pagination = carouselContainer.querySelector('.js-pagination');
        this.prevButton = carouselContainer.querySelector('.js-prev-button');
        this.nextButton = carouselContainer.querySelector('.js-next-button');
        this.images = carouselContainer.querySelectorAll('img');
    }

    initSwiper() {
        this.swiper = new Swiper(this.context, {
            // eslint-disable-line no-undef
            pagination: this.pagination,
            nextButton: this.nextButton,
            prevButton: this.prevButton,

            slidesPerView: 3,
            slidesPerGroup: 3,
            paginationClickable: true,
            grabCursor: true,

            breakpoints: {
                615: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                },
                1023: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
            },
        });
    }
}
